import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditieMedicalaComponent } from './conditie-medicala.component';
import { AddConditieMedicalaComponent } from './add-conditie-medicala/add-conditie-medicala.component';
import { EditConditieMedicalaComponent } from './edit-conditie-medicala/edit-conditie-medicala.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        ConditieMedicalaComponent,
        AddConditieMedicalaComponent,
        EditConditieMedicalaComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [ConditieMedicalaComponent],
})
export class ConditieMedicalaModule { }
